import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Workers } from './Workers';
import {Globals} from '../globals';
@Component({
  selector: 'app-workers',
  templateUrl: './workers.component.html',
  styleUrls: ['./workers.component.scss']
})
export class WorkersComponent implements OnInit {
  workers: Workers;
  selectedDateOn ;
  p: any = 1;
  url ;
  curent;
  collection: any[]=[];
  selectedDateOff ;
  somethingChanged: any;
   dataToSend:any;
  constructor(private http: HttpClient, public globals: Globals , private route: ActivatedRoute) { }

  ngOnInit() {
    $(window).scrollTop(0);
    
   this.changeReq();
  }

  changel(){
    this.changeReq();
   
  }
  changeReq( ) {
    $(window).scrollTop(0);

  if(this.selectedDateOn && this.selectedDateOff) {
    this.http.get<Workers>(this.globals.urlMain +'about_us/working' , {
      params:{
         page: this.p,
        dateon: this.selectedDateOn,
         dateof: this.selectedDateOff,
      }

    }).subscribe(data => {
      this.workers = data;
      var k =Number(data.meta.total);
     this.collection=[];
      for(let i =0 ; i<= k; i++) {
        this.collection.push(i)
      }


    });
   } else {
    this.http.get<Workers>(this.globals.urlMain +'about_us/working' , {
      params:{
         page: this.p,

      }

    }).subscribe(data => {
      this.workers = data;
      var k =Number(data.meta.total);
     this.collection=[];
      for(let i =0 ; i<= k; i++) {
        this.collection.push(i)
      }


    });
   }




  }
}
